import React from 'react';
import Modal from '../util/Modal';
import ValidatedInput from '../util/ValidatedInput';
import Select from '../util/Select';
import AutocompleteInput from '../util/AutocompleteInput';
import { deepEquals, validateFieldLength } from '../../../lib/utils';
import ManualAddressComponent from '../../commonComponents/util/ManualAddressComponent';

export default class AddressModal extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.cancelClick = this.cancelClick.bind(this);
        this.saveClick = this.saveClick.bind(this);
        this.validate = this.validate.bind(this);
        this.update = this.update.bind(this);

        this.state = {
            error: false,
            address: {
                streetNumber: '',
                street: '',
                apartment: '',
                unitType: '',
                city: '',
                state: '',
                zip: '',
                country: ''
            }
        }
    }

    validateZip(value) {
        const isValid = validateFieldLength(5, value);
        this.setState({ error: !isValid });
        return isValid;
    }


    updateZip(values) {
        this.setState({ address: { ...this.state.address, zip: values.value } })

    }


    componentWillReceiveProps(nextProps) {
        if (!deepEquals(this.state.address, nextProps.address)) {
            this.setState({
                address: {
                    streetNumber: nextProps.address.streetNumber || '',
                    street: nextProps.address.street || '',
                    apartment: nextProps.address.apartment || '',
                    unitType: nextProps.address.unitType || '',
                    city: nextProps.address.city || '',
                    state: nextProps.address.state || '',
                    zip: nextProps.address.zip || '',
                    country: nextProps.address.country || ''
                }
            });
        }
    }

    validate() {
        let { ...address } = this.props.address;
        delete address.isManual;
        if (this.state.error) return true;
        let allValuesEmpty = !this.state.address.streetNumber && !this.state.address.street && !this.state.address.apartment
            && !this.state.address.state && !this.state.address.city && !this.state.address.zip && !this.state.address.country && !this.state.address.unitType;
        if ((this.props.address.streetNumber || this.props.address.street || this.props.address.apartment || this.props.address.city || this.props.address.state || this.props.address.zip
            || this.props.address.country)) return deepEquals(address, this.state.address) || allValuesEmpty;
        else return allValuesEmpty;
    }

    cancelClick() {
        this.setState({
            address: {
                streetNumber: '',
                street: '',
                apartment: '',
                unitType: '',
                city: '',
                state: '',
                zip: '',
                country: ''
            }
        });
        this.props.closeModal();
    }

    saveClick() {
        this.props.saveAddress(this.state.address);
    }

    onChange(e) {
        this.setState({ address: { ...this.state.address, [e.target.name]: e.target.value } });
    }

    update = (name) => (value) => {
        this.setState({ address: { ...this.state.address, [name]: value } });
    }



    render() {
        return (
            <Modal
                modalShowing={this.props.modalShowing}>
                <div className="modal-container">
                    <div className="modal large-modal">
                        <div className="modal-header">
                            <h4 className="page-header">Address Not Found</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.cancelClick} />
                        </div>
                        <div className="modal-row">
                            <div className="column-half">
                                <label htmlFor="streetNumber" className="input-label">Street Number <span>*</span></label>
                                <input type="text" value={this.state.address.streetNumber} name="streetNumber"
                                    onChange={this.onChange} />
                            </div>
                            <div className="column-half">
                                <AutocompleteInput overridable={true} placeholder="Search street names"
                                    title="Street *" name="street" value={this.state.address.street}
                                    options={this.props.streetNames.map(s => ({ key: s, value: s }))}
                                    update={(name, val) => this.setState({ address: { ...this.state.address, [name]: val } })} />
                            </div>
                        </div>
                        <div className="modal-row">
                            <div className="column-half">
                                <label className="input-label">Unit Type</label>
                                <Select clearable={true}
                                    options={this.props.unitTypes}
                                    name="unitType" value={this.state.address.unitType}
                                    onChange={this.onChange} />
                            </div>
                            <div className="column-half">
                                <label htmlFor="apartment" className="input-label">Apartment Number</label>
                                <input type="text" name="apartment" onChange={this.onChange}
                                    value={this.state.address.apartment} />
                            </div>
                        </div>
                        <div className="modal-row">
                            <div className="column-half">
                                <ManualAddressComponent label='City' type={'city'} required={true} value={this.state.address.city} onChange={this.update('city')} />
                            </div>
                            <div className="column-half">
                                <ManualAddressComponent label='State' type={'state'} value={this.state.address.state} onChange={this.update('state')} />
                            </div>

                        </div>
                        <div className="modal-row">
                            <div className="column-half">
                                <ValidatedInput input={<input type="text" placeholder="#####" maxLength={7} />}
                                    onChange={(name, val) => this.setState({ address: { ...this.state.address, [name]: val } })}
                                    label="Zip" name="zip" value={this.state.address.zip}
                                    errorMessage="Invalid Zip"
                                    validated={true} showValidationError={true}
                                    validate={this.validateZip.bind(this)} />
                            </div>
                            <div className="column-half">
                                <ManualAddressComponent label='Country' type='country' required={true} value={this.state.address.country} onChange={this.update('country')} />
                            </div>
                        </div>
                        <div className="modal-btns text-right">
                            <button className="btn btn-accent" onClick={this.cancelClick}>Cancel</button>
                            <button className="btn btn-primary" disabled={this.validate()}
                                onClick={this.saveClick}>{(this.props.address.streetNumber || this.props.address.street ||
                                    this.props.address.apartment || this.props.address.city || this.props.address.state || this.props.address.zip || this.props.address.country) ? 'Save Changes' : 'Save'}</button>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/AddressModal.jsx